import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';
import {deleteNotification} from '../../actions/entities/notificationsCenter';
import {getEndpoint} from '../../helpers/endpoint';
import './index.css';

class CreationModule extends React.Component {
  uploadPicture = (formData, key) => {
    const {onChangeInput} = this.props;
    return (dispatch, getState) => {
      fetch(getEndpoint('uploadPicture'), {
        method: 'POST',
        headers: {Authorization: getState().authentication.token},
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            swal({
              title: `Oops...`,
              type: 'error',
              html: `Something went wrong with: "${data.error}"<br/>`,
            });
          } else {
            onChangeInput(data.url, key);
          }
        })
        .catch(error => {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong with: "${error}"<br/>`,
          });
        });
    };
  };

  getOptionsType() {
    const {data} = this.props;
    if (!data.notificationFamily) return <option value="">-</option>;
    if (data.notificationFamily === 'mpg') {
      return (
        <React.Fragment>
          <option value="">-</option>
          <option value="gameWeek">gameWeek</option>
          <option value="mercato">mercato</option>
          <option value="funThings">funThings</option>
          <option value="allUsers">allUsers</option>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <option value="">-</option>
        <option value="partnerNews">partnerNews</option>
      </React.Fragment>
    );
  }

  onCopy() {
    swal({
      title: 'Copied !',
      type: 'success',
    });
  }

  checkDelete(notificationId) {
    const {dispatch} = this.props;
    const onSuccess = () => {
      this.props.history.push({pathname: '/notifications/list'});
    };
    swal({
      title: 'Are you sure ?',
      type: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    })
      .then(() => {
        dispatch(deleteNotification(notificationId, onSuccess));
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    const {data, onChangeInput, dispatch} = this.props;
    const lang = ['fr-FR', 'en-GB', 'es-ES'];
    return (
      <div id="creationModule" className="col-md-6">
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              {!this.props.isCreate
                ? 'Modify notification'
                : 'Create notification'}
            </h3>
          </div>
          <div>
            <div className="infoWrapper">
              <div className="keys">Name</div>
              <div className="name">
                <input
                  className="form-control"
                  value={data.name}
                  onChange={event => onChangeInput(event.target.value, `name`)}
                />
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">notificationFamily</div>
              <div className="name">
                <select
                  className="form-control"
                  value={data.notificationFamily}
                  onChange={event =>
                    onChangeInput(event.target.value, `notificationFamily`)
                  }>
                  <option value="">-</option>
                  <option value="mpg">MPG</option>
                  <option value="players">Players</option>
                </select>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">notificationType</div>
              <div className="name">
                <select
                  className="form-control"
                  value={data.notificationType}
                  onChange={event =>
                    onChangeInput(event.target.value, `notificationType`)
                  }>
                  {this.getOptionsType()}
                </select>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">notificationDate</div>
              <div className="name">
                <DatePicker
                  className="inputDatePicker"
                  selected={
                    data.notificationDate && moment(data.notificationDate)
                  }
                  onChange={date =>
                    date &&
                    onChangeInput(date.utc().format(), `notificationDate`)
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="d/M/yyyy hh:mm aa"
                  timeCaption="time"
                />
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Number of days</div>
              <div className="name">
                <input
                  type="number"
                  className="form-control"
                  value={data.dtl}
                  onChange={event => onChangeInput(event.target.value, `dtl`)}
                />
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Title</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`title${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <input
                        className="form-control"
                        value={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].title
                        }
                        onChange={event =>
                          onChangeInput(
                            event.target.value,
                            `localization.${l}.title`,
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Description</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`descr${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <textarea
                        className="form-control"
                        value={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].description
                            ? data.localization[l].description
                            : ''
                        }
                        onChange={event =>
                          onChangeInput(
                            event.target.value,
                            `localization.${l}.description`,
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Image</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`image${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      {data.localization &&
                        data.localization[l] &&
                        data.localization[l].imageUrl && (
                          <div style={{margin: '10px'}}>
                            <img
                              src={data.localization[l].imageUrl}
                              width="90px"
                              alt=""
                            />
                            <div className="text-center">
                              <i
                                style={{cursor: 'pointer'}}
                                onClick={() =>
                                  onChangeInput(
                                    null,
                                    `localization.${l}.imageUrl`,
                                  )
                                }
                                className="fa fa-trash"
                              />
                            </div>
                          </div>
                        )}
                      <div style={{textAlign: 'center'}}>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            let formData = new FormData();
                            formData.append('file', acceptedFiles[0]);
                            dispatch(
                              this.uploadPicture(
                                formData,
                                `localization.${l}.imageUrl`,
                              ),
                            );
                          }}
                          className="btn btn-warning">
                          Upload
                        </Dropzone>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Youtube Id</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`videoId${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <input
                        className="form-control"
                        value={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].videoId
                        }
                        onChange={event =>
                          onChangeInput(
                            event.target.value,
                            `localization.${l}.videoId`,
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Button text</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`buttonText${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <input
                        className="form-control"
                        value={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].button &&
                          data.localization[l].button.text
                        }
                        onChange={event =>
                          onChangeInput(
                            event.target.value,
                            `localization.${l}.button.text`,
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Link in app</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`linkInApp${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <input
                        type="checkbox"
                        checked={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].button &&
                          data.localization[l].button.linkInApp
                        }
                        onChange={() => {
                          let value = true;
                          if (
                            data.localization &&
                            data.localization[l] &&
                            data.localization[l].button &&
                            data.localization[l].button.linkInApp
                          ) {
                            value = false;
                          }
                          onChangeInput(
                            value,
                            `localization.${l}.button.linkInApp`,
                          );
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Button link</div>
              <div className="name">
                {lang.map(l => (
                  <div className="nameContainer" key={`buttonLink${l}`}>
                    <div>{l}</div>
                    <div
                      className={classNames(
                        'form-group',
                        // nameFrError && 'has-error',
                      )}>
                      <input
                        className="form-control"
                        value={
                          data.localization &&
                          data.localization[l] &&
                          data.localization[l].button &&
                          data.localization[l].button.link
                        }
                        onChange={event =>
                          onChangeInput(
                            event.target.value,
                            `localization.${l}.button.link`,
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="text-center">
            {!this.props.isCreate && (
              <React.Fragment>
                <CopyToClipboard
                  text={`/notifications/${data.id}`}
                  onCopy={() => this.onCopy()}
                  className="btn btn-primary">
                  <p>Link debug</p>
                </CopyToClipboard>
                <button
                  className="btn btn-danger m-3"
                  onClick={() => this.checkDelete(data.id)}>
                  Delete
                </button>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({state}),
    dispatch => ({dispatch}),
    null,
    {pure: false},
  )(CreationModule),
);



// WEBPACK FOOTER //
// ./src/pages/Notifications/CreationModule.js